import apiClient from "../../../../utilities/apiClient";

export const signUp = (payload) => {
  return apiClient.post(`${apiClient.Urls.signup}`, payload);
};
export const token_status = (payload) => {
  return apiClient.post(`${apiClient.Urls.check_token_status}`, payload, true);
};
